import i18n from '@/lang/index'
// 导出配置的路由器
export default [{
	path: '/maintenanceCenter',
	component: () => import('@/layout/index'),
	redirect: 'maintenanceCenter/controlManage',
	meta: {
		title: i18n.t('yun-wei-zhong-xin'),
		icon: 'icon-yunwei',
		perms: ['bee:ops']
	},
	children: [{
			path: 'controlManage',
			component: () => import('@/module/maintenanceCenter/page/remoteControl/controlManage.vue'),
			meta: {
				icon: 'icon-caozuo',
				title: i18n.t('yuan-cheng-kong-zhi'),
				perms: ['bee:ops:commandRecord']
			}
		},
    {
      path: 'alarmcharginggunManager',
      component: () => import('@/module/maintenanceCenter/page/alarmcharginggunManager.vue'),
      meta: {
        icon: 'icon-shebei2',
        title: "告警枪",
      }
    },
		/*{
			path: 'groundLockManage',
			component: () => import('@/module/maintenanceCenter/page/groundLockManager/manage.vue'),
			meta: {
				icon: 'icon-shebei2',
			  title: i18n.t('ground-lock-management'),
			}
	  },*/
		{
			path: 'customerPraiseManage',
			component: () => import('@/module/maintenanceCenter/page/customerPraise/manage.vue'),
			meta: {
				icon: 'icon-pingjia',
				title: i18n.t('ding-dan-ping-jia'),
				perms: ['bee:ops:customerPraise']
			}
		},
		{
			path: 'faultRepairAdvice',
			component: () => import('@/module/maintenanceCenter/page/faultRepair/manage.vue'),
			meta: {
				icon: 'icon-wenti',
				title: i18n.t('gu-zhang-bao-xiu'),
				perms: ['bee:ops:faultRepair']
			}
		},
		{
			path: 'saleServiceManage',
			component: () => import('@/module/maintenanceCenter/page/saleService/manage.vue'),
			meta: {
				icon: 'icon-shouhou1',
				title: i18n.t('shou-hou-fu-wu'),
				perms: ['bee:ops:saleService']
			}
		},
		{
			path: 'monitoringLog',
			component: () => import('@/module/maintenanceCenter/page/monitoringLog/manage.vue'),
			meta: {
				icon: 'icon-yunwei',
				title: i18n.t('yun-wei-jian-kong'),
				perms: ['bee:ops:monitoringLog']
			}
		},
		{
			path: 'feedbackManager',
			component: () => import('@/module/maintenanceCenter/page/feedback.vue'),
			meta: {
				icon: 'icon-shouhou1',
			title: i18n.t('fan-kui-fu-wu'),
			perms: ['bee:ops:feedback']
			}
		}

	]
}]



// WEBPACK FOOTER //
// ./src/module/maintenanceCenter/router/index.js